var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__st0 {\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-linecap: round;\n\t\t\tstroke-linejoin: round;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M11.8 11.8h.5c1.4 0 2.6 1.1 2.6 2.4 0 1.3-1.2 2.4-2.6 2.4 0 0-1.8.2-3.3-1.2M12.1 11.8h-.5c-1.3 0-2.4-1-2.4-2.2 0-1.2 1.1-2.2 2.4-2.2 0 0 1.7-.2 3.1 1.1M11.9 5.5v13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.5c1.1 0 2 .9 2 2v13c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-13c0-1.1.9-2 2-2h18m0-1H3c-1.6 0-3 1.3-3 3v13c0 1.6 1.4 3 3 3h18c1.6 0 3-1.4 3-3v-13c0-1.7-1.4-3-3-3z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashCards);
export default __webpack_public_path__ + "static/media/cash-cards.2e31aa8e9376fe47a8a5912eaf9f81d3.svg";
export { ForwardRef as ReactComponent };